export const APOLICE = {
  COOPMETRO: '007.5.01.53000009',
};
